/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModelInferenceResponse
 */
export interface AIModelInferenceResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AIModelInferenceResponse
     */
    annotations: Array<string>;
}

export function AIModelInferenceResponseFromJSON(json: any): AIModelInferenceResponse {
    return AIModelInferenceResponseFromJSONTyped(json, false);
}

export function AIModelInferenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelInferenceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'annotations': json['annotations'],
    };
}

export function AIModelInferenceResponseToJSON(value?: AIModelInferenceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'annotations': value.annotations,
    };
}


